var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import { H } from "@jfrk/react-heading-levels";
import clsx from "clsx";
import React, { useState } from "react";
import { Icon } from "@whitespace/components";
import { useID } from "../hooks";
import * as defaultStyles from "./Accordion.module.css";
import withComponentDefaults from "../utils/withComponentDefaults";
import { filterAttributes } from "../utils";
export default withComponentDefaults(Accordion, "accordion");
const DefaultExpandIcon = props => /* @__PURE__ */React.createElement(Icon, __spreadValues({
  name: "chevron-down"
}, props));
const DefaultCollapseIcon = props => /* @__PURE__ */React.createElement(Icon, __spreadValues({
  name: "chevron-up"
}, props));
function Accordion(_a) {
  var _b = _a,
    {
      components: {
        ExpandIcon = DefaultExpandIcon,
        CollapseIcon = DefaultCollapseIcon
      } = {
        ExpandIcon: DefaultExpandIcon,
        CollapseIcon: DefaultCollapseIcon
      },
      items,
      styles = defaultStyles,
      className,
      showExpandAll
    } = _b,
    restProps = __objRest(_b, ["components", "items", "styles", "className", "showExpandAll"]);
  let attributes = filterAttributes(restProps);
  const [expandedRowIndexes, setExpandedRowIndexes] = useState([]);
  const id = useID();
  function rowIsExpanded(index) {
    return expandedRowIndexes.indexOf(index) !== -1;
  }
  const onExpandAllButtonClick = () => {
    const atLeastOneRowIsExpanded = expandedRowIndexes.length;
    if (atLeastOneRowIsExpanded) {
      setExpandedRowIndexes([]);
    } else {
      const allRowIndexes = Array.from(Array(items.length).keys());
      setExpandedRowIndexes(allRowIndexes);
    }
  };
  return /* @__PURE__ */React.createElement("div", __spreadValues({
    className: clsx(styles.component, className)
  }, attributes), showExpandAll && /* @__PURE__ */React.createElement("button", {
    onClick: onExpandAllButtonClick
  }, expandedRowIndexes.length ? /* @__PURE__ */React.createElement(React.Fragment, null, "ST\xC4NG") : /* @__PURE__ */React.createElement(React.Fragment, null, "\xD6PPNA")), /* @__PURE__ */React.createElement("ul", {
    className: clsx(styles.list),
    id: id("accordion")
  }, items.map((row, index) => {
    return /* @__PURE__ */React.createElement("li", {
      className: clsx(styles.row),
      key: index
    }, /* @__PURE__ */React.createElement(H, {
      className: clsx(styles.title)
    }, /* @__PURE__ */React.createElement("button", {
      id: id("accordion-header-".concat(index)),
      "aria-expanded": rowIsExpanded(index),
      "aria-controls": id("accordion-panel-".concat(index)),
      className: clsx(styles.button),
      onClick: () => {
        if (!rowIsExpanded(index)) {
          setExpandedRowIndexes([...expandedRowIndexes, index]);
        } else {
          setExpandedRowIndexes(expandedRowIndexes.filter(currIndex => currIndex !== index));
        }
      }
    }, /* @__PURE__ */React.createElement("span", {
      className: clsx(styles.icon),
      "aria-hidden": "true"
    }, !rowIsExpanded(index) ? /* @__PURE__ */React.createElement(ExpandIcon, null) : /* @__PURE__ */React.createElement(CollapseIcon, null)), row.title)), /* @__PURE__ */React.createElement("section", {
      id: id("accordion-panel-".concat(index)),
      "aria-labelledby": id("accordion-header-".concat(index)),
      hidden: !rowIsExpanded(index),
      className: clsx(styles.content)
    }, row.content));
  })));
}